export default {
	methods: {
		removeLoader () {
			setTimeout (() => {
				this.$store.dispatch('setLoading', false)
			}, 100)
			setTimeout (() => {
				this.$store.dispatch('setReady', true)
			}, 200)
		}
	}
}
